import { Brand, Enterprise } from 'apis/enterprise/types';
import { DraftVenue } from 'apis/merchant-onboarding-service/types';
import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

import { useGetBrandsForUser } from './useGetBrandsForUser';
import useGetDraftVenues from './useGetDraftVenues';
import { useGetEnterprisesForUser } from './useGetEnterprisesForUser';
import useGetMerchants from './useGetMerchants';
import useGetVenues from './useGetVenues';

export type GetEntitiesForUserState = {
  brands: Brand[];
  enterprises: Enterprise[];
  draftVenues: DraftVenue[];
  isLoading: boolean;
  merchants: Merchant[];
  venues: Venue[];
};

export const useGetEntitiesForUser = (): GetEntitiesForUserState => {
  const { merchants, isLoading: isLoadingMerchants } = useGetMerchants();

  const { venues, isLoading: isLoadingVenues } = useGetVenues(true);
  const isDraftVenuesFetchEnabled = !isLoadingMerchants && merchants.length > 0;
  const merchantIds = merchants.map(merchant => merchant.itemid.$oid);
  const { draftVenues, isLoading: isLoadingDraftVenues } = useGetDraftVenues(isDraftVenuesFetchEnabled, merchantIds);

  const { enterprises, isLoading: isLoadingEnterprises } = useGetEnterprisesForUser();
  const { brands, isLoading: isLoadingBrands } = useGetBrandsForUser();

  return {
    brands,
    draftVenues,
    enterprises,
    merchants,
    venues,
    isLoading:
      isLoadingMerchants ||
      (isDraftVenuesFetchEnabled && isLoadingDraftVenues) ||
      isLoadingVenues ||
      isLoadingEnterprises ||
      isLoadingBrands,
  };
};
